import React, { useState } from 'react';
import { t } from 'ttag';
import Price from '../../utils/prices';
import { currency } from '../data';
import './detailComponent.scss';

export default function DetailComponent(props) {
  const [image, setImage] = useState(props.shirt.image);

  const adults = props.shirt.product_groups.filter(g => g.category === 1)[0];
  const kids = props.shirt.product_groups.filter(g => g.category === 2)[0];

  let collectionTitle = '';
  const title = adults.title.toLowerCase();
  const brandLower = props.brand.toLowerCase();
    if (title.includes(brandLower)) {
      collectionTitle = title.replace(brandLower, '').trim();
    } else {
      collectionTitle = title;
    }

  const price_5 = new Price(adults.price_5, currency);
  const price_9 = new Price(adults.price_9, currency);
  const price_13 = new Price(adults.price_13, currency);

  const handleImage404Error = () => {
    setImage(null);
  };

  return (
    <div className="detailComponent" key={props.shirt.name} style={props.style}>
      <div className="imageHolder">
        {props.shirt.image &&
        <picture>
          <source media="(min-width: 768px)" srcSet={image || ''} />
          <source srcSet={image || ''} />
          <img onError={() => handleImage404Error()} src={image || ''} alt={`${props.brand} ${adults.title}`} />
        </picture>
        }
      </div>
      <div className="textHolder">
        <p className="title">{props.brand}</p>
        <p className="title">{collectionTitle}</p>
        <div className="innerTextHolder">
          <div>
            <div className="text">{props.shirt.text}</div>
            <div className="pricepoints text">
              <div className="subtitle">{t`Prices For Adults`}</div>

              <div className="bullet">{`5+1: ${t`From`} ${price_5.toString()}`}</div>
              <div className="bullet">{`9+1: ${t`From`} ${price_9.toString()}`}</div>
              <div className="bullet">{`13+1: ${t`From`} ${price_13.toString()}`}</div>
              {adults &&
              <a href={`/teamsport/#/colors/${adults.id}/`}>
                <button type="button">{t`Shop Adults`}</button>
              </a>
              }
              {kids &&
              <a href={`/teamsport/#/colors/${kids.id}/`}>
                <button type="button">{t`Shop Kids`}</button>
              </a>
              }
            </div>
            {props.shirt.colors.length > 0 &&
            <div className="availableColors">
              <div className="subtitle">{`${t`Available colours`}:`}</div>
              <br />
              <div className="colors">
                {props.shirt.colors.length > 0 && props.shirt.colors
                .map(color => color.color_image && (
                  <div
                    key={color.id}
                    // className={(((props.shirt.colors / 2) > i)
                    // && ((props.shirt.colors / 2) <= (i + 1))) ?
                    // `color break ${props.shirt.name}` : 'color'}
                    className="color"
                  >
                    <img
                      src={color.color_image}
                      alt="shirt color"
                    />
                  </div>
                  ))}
              </div>
            </div>
            }
          </div>

        </div>
      </div>
    </div>
  );
}
